import { render, staticRenderFns } from "./Vaccini.vue?vue&type=template&id=22b3d1e6&"
import script from "./Vaccini.vue?vue&type=script&lang=ts&"
export * from "./Vaccini.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports